module.exports = __webpack_public_path__ + "img/hr-brown-fluff-dry-02.ca17fc9d.png";